import { useAuth, canSee, PANELS } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, panel }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (panel && !canSee(user, panel)) {
    const first = PANELS.find((p) => canSee(user, p.id));
    return first ? <Navigate to={first.path} replace /> : (
      <div className="flex h-screen items-center justify-center p-8 text-center text-sm text-muted-foreground" data-testid="no-access">
        Non hai ancora accesso a nessun pannello: chiedi al proprietario di abilitarti.
      </div>
    );
  }
  return children;
}
